import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo, useContext } from 'react';
import { useSelector } from 'react-redux';
import { AppContext } from 'context';
import Button from 'components/Form/Button';
import App from 'modules/App';
const BackBtn = ({ returnUrl, asCancel = false })=>{
    const { getUrl } = useContext(AppContext);
    const isMobileDisplayMode = useSelector(App.selectors.isMobileDisplayMode);
    const signIn = returnUrl ? `${getUrl('sign-in')}?ReturnUrl=${encodeURIComponent(returnUrl)}` : getUrl('sign-in');
    return /*#__PURE__*/ _jsx(Button, {
        type: "link",
        to: signIn,
        styleModifier: isMobileDisplayMode ? 'secondary' : 'primary',
        labelMessage: App.messages.buttons[asCancel ? 'cancel' : 'back'],
        className: "btn--block"
    });
};
export default /*#__PURE__*/ memo(BackBtn);
